var map = {
	"./chatClientStorageUtilityService.js": 61,
	"./chatService.js": 62,
	"./chatUtilityService.js": 63,
	"./cookieService.js": 64,
	"./dialogAttributesService.js": 65,
	"./gameLayoutService.js": 66,
	"./gameService.js": 67,
	"./gameUtility.js": 68,
	"./libraryInitializationService.js": 69,
	"./messageService.js": 70,
	"./messageUtility.js": 71,
	"./pinGameLayoutService.js": 72,
	"./pinGameService.js": 73,
	"./playTogetherLayoutService.js": 74,
	"./playTogetherService.js": 75,
	"./presenceLayoutService.js": 76,
	"./storageService.js": 77,
	"./systemMessagesService.js": 78,
	"./usersService.js": 79,
	"./voiceService.js": 80
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 60;